export enum DailyPauseStatsHeaderTestID {
    Header = 'DailyPauseStatsHeader.Header',
    Description = 'DailyPauseStatsHeader.Description',
    Link = 'DailyPauseStatsHeader.Link',
}

export enum DailyPauseStatsSubHeaderTestID {
    Text = 'DailyPauseSubHeader.Text',
    Button = 'DailyPauseSubHeader.Button',
}

export enum DailyPauseTileTestID {
    Tile = 'DailyPauseTileTestID.Tile',
    Stats = 'DailyPauseTileTestID.Stats',
}

export enum MilestoneListTestID {
    Badge = 'MilestoneListTestID.Badge',
}

export enum DailyPauseCardTestID {
    Container = 'DailyPauseCardTestID.Container',
    Button = 'DailyPauseCardTestID.Button',
    Graphic = 'DailyPauseCardTestID.Graphic',
    TextDate = 'DailyPauseCardTestID.TextDate',
    TextTitle = 'DailyPauseCardTestID.TextTitle',
    TextContent = 'DailyPauseCardTestID.TextContent',
}
